import React from 'react';
import { aboutContent, companyInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-black">
      <div className="container mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="max-w-4xl mb-16 md:mb-20">
          <span className="text-gray-500 text-sm uppercase tracking-widest font-medium mb-4 block">
            {aboutContent.subtitle}
          </span>
          <h2 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase">
            {aboutContent.title}
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Story */}
          <div className="order-2 lg:order-1">
            <div className="prose prose-lg max-w-none">
              {aboutContent.story.split('\n\n').map((paragraph, index) => (
                <p key={index} className="text-gray-400 text-lg leading-relaxed mb-6">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img
                src={companyInfo.farmImage}
                alt="AR Tarım Çiftliği"
                className="w-full aspect-[4/3] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute -bottom-6 -left-6 bg-white text-black p-6 hidden md:block">
                <p className="text-sm uppercase tracking-widest font-semibold">Ezine, Türkiye</p>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-3 gap-8 mt-24 pt-16 border-t border-gray-800">
          {aboutContent.values.map((value, index) => (
            <div key={index} className="group">
              <div className="mb-4">
                <span className="text-gray-700 text-6xl font-bold">
                  0{index + 1}
                </span>
              </div>
              <h3 className="text-white text-xl font-bold uppercase tracking-wide mb-3">
                {value.title}
              </h3>
              <p className="text-gray-500 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
